<div class="booble-backdrop-drawer-right">
  <div class="drawer-rtl-in">
    <div class="drawer-content-lg">
      <div class="row padding-left-32 drawer-header">
        <div class="col-md-11">
          <div class="d-flex flex-column">
            <h2 class="title-modal">Informações para boletar no Exchange</h2>
            <p class="p-text-grey-scale-dark mg-bottom-24">
              Confira as informações da ordem para para criação do boleto no
              Exchange
            </p>
          </div>
        </div>

        <div class="col-md-1 d-flex justify-content-end mg-top-10">
          <div (click)="closeModal()" class="close-icon tappable">
            <img src="assets/image/close-modal-icon.svg" />
          </div>
        </div>
      </div>
      <div class="modal-dialog-scrollable-general">
        <div class="modal-body h-100">
          <div class="box-order">
            <app-order-data
              [boobleModalData]="boobleModalData"
              [rType]="rType"
              [commercial]="commercial"
              [ir]="ir"
              [iof]="iof"
              [currency]="currency"
              [showDocuments]="true"
            ></app-order-data>
          </div>
        </div>
      </div>

      <div class="modal-footer-new" [style.justify-content]="'space-between'">
        <button
          type="button"
          [style.width]="'134px'"
          class="btn-outline-dark btn"
          (click)="closeModal()"
          type="button"
        >
          Fechar
        </button>
        <!--    <button
          type="button"
          class="btn-footer btn btn-dark-primary-blue"
          type="button"
          [disabled]="isLoading"
          (click)="openExchangeInfoConfirmModal(this.boobleModalData)"
        >
          Confirmar que o boleto foi criado no Exchange
        </button> -->
        <button
          type="button"
          class="btn-footer btn btn-dark-primary-blue"
          type="button"
          [disabled]="isLoading"
          (click)="sendExchange(this.boobleModalData)"
        >
          Gerar boleto no exchange
        </button>
      </div>
    </div>
  </div>
</div>
